import React, { useState, useEffect } from 'react';
import { object, func, bool, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { ALERT_TYPE, ShowToastMessage, sequenceActionNext } from '@laramie/ui';
import { TableCustom, MessageModal } from '../../common';
import { CloneObject } from '../../../utils/helpers';
import RubroComercioModal from '../RubroComercioModal';
import { getDateToString, getBooleanToString } from '../../../utils/convert';
import DataTaggerModalRedux from '../DataTaggerModalRedux';
import { isNull } from '../../../utils/validator';
import { useEntidad } from '../../hooks';
import {TIPS} from "../../../consts/tips";

const RubrosComercioGrid = (props) => {

    //hooks
    const [state, setState] = useState({
        idComercio: 0,
        disabled: false,
        showMessage: false,
        showForm: false,
        modeFormEdit: false,
        rowForm: null,
        showChildren: false,
        dataTagger: {
            showModal: false,
            idEntidad: null
        }, 
        list: [],
    });

    const [isFirstRubroState, setIsFirstRubroState] = useState(false);

    const dispatch = useDispatch();
    const sequenceValue = useSelector( (state) => state.sequence.value );

    const mount = () => {
        const list = props.data.list.filter(x => x.state !== 'r');
        setState(prevState => {
            return {...prevState,
                idComercio: props.data.idComercio,
                list: list };
        });     
    }
    useEffect(mount, [props.data]);


    const [, getRowEntidad] = useEntidad({
        entidades: ['Rubro'],
        onLoaded: (entidades, isSuccess, error) => {
          if (isSuccess) {
            setState(prevState => ({...prevState}));
          }
          else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        },
        memo: {
          key: 'Rubro',
          timeout: 0
        }
    });

    const getDescRubro = (id) => {
        const row = getRowEntidad('Rubro', id);
        return (row) ? row.nombre : '';
    }

    const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                    <div onClick={ (event) => handleClickRubrosComercioAdd() } className="link">
                                       <span className="material-symbols-outlined" title="Nuevo">add</span>
                                    </div>
                                )}
                              </div>
    const cellVMR = (data) =>  <div className='action'>
                                  <div onClick={ (event) => handleClickRubrosComercioView(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Ver">search</span>
                                  </div>
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickRubrosComercioModify(data.value) } className="link">
                                    <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                  </div>
                                  )}
                                  {!props.disabled && (
                                  <div onClick={ (event) => handleClickRubrosComercioRemove(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                  </div>
                                  )}
                                  <div onClick={ (event) => handleClickRubrosComercioDataTagger(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Información adicional">info</span>
                                  </div>                                  
                              </div>

    const tableColumns = [
        { Header: 'Rubro', Cell: (props) => `${props.value} - ${getDescRubro(props.value)}`, accessor: 'idRubro', width: '20%' },
        { Header: 'Descripción', accessor: 'descripcion', width: '30%' },
        { Header: 'Principal', Cell: (props) => getBooleanToString(props.value), accessor: 'esRubroPrincipal', width: '10%' },
        { Header: 'Inicio', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaInicio', width: '15%' },
        { Header: 'Baja', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaBaja', width: '15%' },
        { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true }
    ];

    //handles
    const handleClickRubrosComercioAdd = () => {
        setIsFirstRubroState(state.list.length === 0);

        const idTemporal = (-1)*sequenceValue; //los registros temporales tienen id negativa
        setState(prevState => {
            const rowForm = {
                id: idTemporal,
                idComercio: state.idComercio,
                idRubro: 0,
                idUbicacionComercio: 0,
                idRubroLiquidacion: 0,
                idRubroProvincia: 0,
                idRubroBCRA: 0,
                descripcion: '',
                esDeOficio: false,
                esRubroPrincipal: false,
                esConDDJJ: false,
                fechaInicio: null,
                fechaCese: null,
                fechaAltaTransitoria: null,
                fechaBajaTransitoria: null,
                fechaBaja: null,
                idMotivoBajaRubroComercio: 0,
                state: 'a'
            };

            return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm, showChildren: false};
        });
        dispatch( sequenceActionNext() );
    }

    const handleClickRubrosComercioView = (id) => {
        setState(prevState => {
          const rowForm = state.list.find(x => x.id === id);
          return {...prevState, showForm: true, modeFormEdit: false, rowForm: rowForm, showChildren: true};
        });
    }

    const handleClickRubrosComercioModify = (id) => {
        setIsFirstRubroState(state.list.length === 1);
        setState(prevState => {
            const rowForm = state.list.find(x => x.id === id);
            return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm, showChildren: true};
        });
      }
    
    const handleClickRubrosComercioRemove = (id) => {
        setState(prevState => {
            const rowForm = state.list.find(x => x.id === id);
            return {...prevState, showMessage: true, rowForm: rowForm};
        });
    }

    const handleClickRubrosComercioDataTagger = (id) => {
        setState(prevState => {
          return {...prevState, dataTagger: {showModal: true, idEntidad: id}};
        });
    }    

    //funciones
    function RemoveRubroComercio(row) {
        row.state = 'r';
        if (row.esRubroPrincipal){
            const listWithoutRow = state.list.filter(value => row.id != value.id);
            const listRubroPrincipal = listWithoutRow.filter(value => value.esRubroPrincipal);
            if (listWithoutRow.length > 0 && listRubroPrincipal.length !== 1){
                ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe marcar un rubro como principal');
                return;
            }
        }
        props.onChange('RubroComercio', [row]);
    }

    function UpdateRubroComercio(row) {
        row.state = isNull(state.list.find(x => x.id === row.id)) ? 'a' : 'm';
        let updateList = [row];
        // se vuelve a permitir seleccionar mas de un rubro principal
        // if (row.esRubroPrincipal){
        //     state.list.forEach(v => {
        //         let value = CloneObject(v);
        //         if (row.id != value.id && value.esRubroPrincipal){
        //             value.esRubroPrincipal = false;
        //             value.state = 'm';
        //             updateList.push(value);
        //         }
        //     });
        // }

        props.onChange('RubroComercio', updateList);
    }


    return (
    <>

        {state.dataTagger.showModal &&
            <DataTaggerModalRedux
                title="Información adicional de rubros comercio"
                tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_RUBRO_COMERCIO_MODAL}
                processKey={props.processKey}
                entidad="RubroComercio"
                idEntidad={state.dataTagger.idEntidad}
                disabled={props.disabled}
                onDismiss={() => {
                setState(prevState => {
                    return {...prevState, dataTagger: {showModal: false, idEntidad: null}};
                });
                }}
            />
        }

        {state.showMessage && 
            <MessageModal
                title={"Confirmación"}
                message={"¿Está seguro de borrar el registro?"}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showMessage: false, rowForm: null};
                    });
                }}
                onConfirm={() => {
                    const row = CloneObject(state.rowForm);
                    setState(prevState => {
                        return {...prevState, showMessage: false, rowForm: null};
                    });
                    RemoveRubroComercio(row);
                }}
            />
        }

        {state.showForm && 
            <RubroComercioModal
                processKey={props.processKey}
                disabled={!state.modeFormEdit}
                showChildren={state.showChildren}
                data={{
                    entity: state.rowForm,
                    idCuenta: props.data.idCuenta,
                    isFirstRubro: isFirstRubroState
                }}
                onDismiss={() => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowForm: null};
                    });
                }}
                onConfirm={(row) => {
                    setState(prevState => {
                        return {...prevState, showForm: false, rowForm: null};
                    });
                    UpdateRubroComercio(row);
                }}
                onMovePrevious={(!state.modeFormEdit && state.rowForm && state.list.length > 1) ? () => {
                    const index = state.list.indexOf(state.list.find(x => x.id === state.rowForm.id));
                    const previousIndex = (index === 0) ? (state.list.length - 1) : (index - 1);
                    const previousId = state.list[previousIndex].id;
                    handleClickRubrosComercioView(previousId);
                  } : null}
                onMoveNext={(!state.modeFormEdit && state.rowForm && state.list.length > 1) ? () => {
                    const index = state.list.indexOf(state.list.find(x => x.id === state.rowForm.id));
                    const nextIndex = (index === state.list.length - 1) ? 0 : (index + 1);
                    const nextId = state.list[nextIndex].id;
                    handleClickRubrosComercioView(nextId);
                } : null}
            />
        }

        <TableCustom
            showFilterGlobal={false}
            className={'TableCustomBase'}
            columns={tableColumns}
            data={ state.list }
        />

    </>
    );
}

RubrosComercioGrid.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onChange: func.isRequired
};
  
RubrosComercioGrid.defaultProps = {
    disabled: false
};

export default RubrosComercioGrid;